<label class="ui-switch" [class.ui-switch--disabled]="disabled">
  <input
    class="ui-switch__input"
    type="checkbox"
    role="switch"
    [checked]="checked"
    [disabled]="disabled"
    [id]="id || null"
    (change)="toggle($event)"
  />
  <span class="ui-switch__track" aria-hidden="true">
    <span class="ui-switch__thumb"></span>
  </span>
  <span class="ui-switch__text">
    @if (label) {
      <span class="ui-switch__label">{{ label }}</span>
    }
    @if (hint) {
      <span class="ui-switch__hint">{{ hint }}</span>
    }
  </span>
</label>
